var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E5EC0A16-4038-4680-A24F-F9827EB305E3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S---Warranty---Connected-Vehicle-Warranty-Active-(EU)",
    transform: "translate(-172.000000, -876.000000)",
    fill: "#00095B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-X-Dependencies-/-24x24-/-Information",
    transform: "translate(172.000000, 876.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.000304,0 C18.6282906,0 24,5.37184555 24,12 C24,18.6275464 18.6282906,24 12.000304,24 C5.37231752,24 0,18.6275464 0,12 C0,5.37184555 5.37231752,0 12.000304,0 Z M12.000304,2 C6.47675101,2 2,6.47655104 2,12 C2,17.5230666 6.47697671,22 12.000304,22 C17.523484,22 22,17.5232139 22,12 C22,6.4764037 17.5237097,2 12.000304,2 Z M12,9 C12.5522847,9 13,9.49746139 13,10.1111111 L13,17.8888889 C13,18.5025386 12.5522847,19 12,19 C11.4477153,19 11,18.5025386 11,17.8888889 L11,10.1111111 C11,9.49746139 11.4477153,9 12,9 Z M12,5 C12.5522847,5 13,5.44771525 13,6 C13,6.55228475 12.5522847,7 12,7 C11.4477153,7 11,6.55228475 11,6 C11,5.44771525 11.4477153,5 12,5 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.7e04ed7a1edc934952a4be13b0826d71.svg";
export { ForwardRef as ReactComponent };